const css = `@charset "UTF-8";
.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-m-b-negative-3 {
  margin-bottom: -3px;
}

.rbc-h-full {
  height: 100%;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full, .rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #999999;
}

.rbc-off-range-bg {
  background: #e6e6e6;
}

.rbc-header {
  overflow: hidden;
  flex: 1 0 0%;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  border-bottom: 1px solid #ddd;
}
.rbc-header + .rbc-header {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-button-link {
  color: inherit;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  user-select: text;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
}

.rbc-row-content-scrollable {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.rbc-row-content-scrollable .rbc-row-content-scroll-container {
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari and Opera */
}
.rbc-row-content-scrollable .rbc-row-content-scroll-container::-webkit-scrollbar {
  display: none;
}

.rbc-today {
  background-color: #eaf6ff;
}

.rbc-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #373a3c;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: none;
  background-image: none;
  border: 1px solid #ccc;
  padding: 0.375rem 1rem;
  border-radius: 4px;
  line-height: normal;
  white-space: nowrap;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: #e6e6e6;
  border-color: #adadad;
}
.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {
  color: #373a3c;
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}
.rbc-toolbar button:focus {
  color: #373a3c;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.rbc-toolbar button:hover {
  color: #373a3c;
  background-color: #e6e6e6;
  border-color: #adadad;
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {
  margin-left: 10px;
}

@media (max-width: 767px) {
  .rbc-toolbar {
    flex-direction: column;
  }
}
.rbc-event, .rbc-day-slot .rbc-background-event {
  border: none;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0;
  padding: 2px 5px;
  background-color: #3174ad;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
.rbc-slot-selecting .rbc-event, .rbc-slot-selecting .rbc-day-slot .rbc-background-event, .rbc-day-slot .rbc-slot-selecting .rbc-background-event {
  cursor: inherit;
  pointer-events: none;
}
.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {
  background-color: #265985;
}
.rbc-event:focus, .rbc-day-slot .rbc-background-event:focus {
  outline: 5px auto #3b99fc;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  color: #3174ad;
}
.rbc-show-more:hover, .rbc-show-more:focus {
  color: #265985;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0 0;
  flex-basis: 0px;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #ddd;
}

.rbc-date-cell {
  flex: 1 1 0;
  min-width: 0;
  padding-right: 5px;
  text-align: right;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0 0;
  overflow: hidden;
  right: 1px;
}

.rbc-day-bg {
  flex: 1 0 0%;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  overflow: auto;
}
.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #ddd;
  border-spacing: 0;
  border-collapse: collapse;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #ddd;
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #ddd;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  margin-right: 10px;
  top: 0;
}
.rbc-day-slot .rbc-events-container.rbc-rtl {
  left: 10px;
  right: 0;
}
.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {
  border: 1px solid #265985;
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}
.rbc-day-slot .rbc-background-event {
  opacity: 0.75;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1 0;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid #f7f7f7;
}

.rbc-time-view-resources .rbc-time-gutter,
.rbc-time-view-resources .rbc-time-header-gutter {
  position: sticky;
  left: 0;
  background-color: white;
  border-right: 1px solid #ddd;
  z-index: 10;
  margin-right: -1px;
}
.rbc-time-view-resources .rbc-time-header {
  overflow: hidden;
}
.rbc-time-view-resources .rbc-time-header-content {
  min-width: auto;
  flex: 1 0 0;
  flex-basis: 0px;
}
.rbc-time-view-resources .rbc-time-header-cell-single-day {
  display: none;
}
.rbc-time-view-resources .rbc-day-slot {
  min-width: 140px;
}
.rbc-time-view-resources .rbc-header,
.rbc-time-view-resources .rbc-day-bg {
  width: 140px;
  flex: 1 1 0;
  flex-basis: 0 px;
}

.rbc-time-header-content + .rbc-time-header-content {
  margin-left: -1px;
}

.rbc-time-slot {
  flex: 1 0 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  border: 1px solid #ddd;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
  text-align: right;
}
.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {
  border-left: 1px solid #ddd;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #ddd;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #ddd;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #ddd;
}
.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
}

.rbc-time-header-cell-single-day {
  display: none;
}

.rbc-time-header-content {
  flex: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-time-header-content > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
}

.rbc-time-content {
  display: flex;
  flex: 1 0 0%;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #ddd;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-resource-grouping.rbc-time-header-content {
  display: flex;
  flex-direction: column;
}
.rbc-resource-grouping .rbc-row .rbc-header {
  width: 141px;
}

.reservation-page .reservation-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
}
.reservation-page .reservation-card .p-skeleton {
  background-color: var(--surface-ground);
}
.reservation-page .reservation-card .p-skeleton::after {
  background: linear-gradient(90deg, transparent, var(--shimmer), transparent);
}
.reservation-page .reservation-card .reservation-calendar.big-slots .rbc-timeslot-group {
  min-height: 100px;
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-content {
  overscroll-behavior: auto;
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-content > * + * > * {
  border-left: 2.5px solid var(--surface-300);
  border-right: 1.5px solid var(--surface-300);
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-content > .rbc-time-gutter + * > * {
  border-left-width: 1px;
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-content > *:last-child > * {
  border-right: none;
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-header .rbc-time-header-content {
  border-left: none;
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-header .rbc-time-header-content .rbc-header {
  border-left: none;
  border-right: none;
  box-shadow: inset 2.5px 0 0 var(--surface-300), inset -1.5px 0 0 var(--surface-300);
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-header .rbc-time-header-content .rbc-header:first-child {
  box-shadow: inset 1px 0 0 var(--surface-300), inset -1.5px 0 0 var(--surface-300);
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-header .rbc-time-header-content .rbc-header:last-child {
  box-shadow: inset 2.5px 0 0 var(--surface-300);
}
.reservation-page .reservation-card .reservation-calendar .rbc-time-header-gutter,
.reservation-page .reservation-card .reservation-calendar .rbc-time-gutter {
  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
}
.reservation-page .reservation-card .reservation-calendar .rbc-allday-cell {
  display: none;
}
.reservation-page .reservation-card .reservation-calendar .rbc-label {
  max-width: 44px !important;
  min-width: 44px !important;
}
.reservation-page .reservation-card .p-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.reservation-page .reservation-card .p-card-content {
  flex: 1;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.reservation-page .reservation-card .reservation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.reservation-page .reservation-card .reservation-header .header-left {
  display: flex;
  gap: 16px;
}
.reservation-page .reservation-card .reservation-header .header-right {
  display: flex;
  gap: 8px;
}
.reservation-page .reservation-card .admin-filters {
  display: flex;
  margin-bottom: 16px;
  gap: 16px;
  justify-content: end;
}
.reservation-page .reservation-card .filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}
.reservation-page .reservation-card .filters-container .branch-select,
.reservation-page .reservation-card .filters-container .employee-select,
.reservation-page .reservation-card .filters-container .type-select {
  min-width: 200px;
}
.reservation-page .reservation-card .filters-container .switch-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.reservation-page .reservation-card .calendar-filters .filter-item:focus-within {
  z-index: 31;
}
.reservation-page .reservation-card .calendar-fullscreen-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.reservation-page .reservation-card .calendar-fullscreen-container .fullscreen-toggle-button .pi {
  font-size: var(--font-size-sm);
  vertical-align: middle;
}
.reservation-page .reservation-card .calendar-fullscreen-container .rbc-toolbar,
.reservation-page .reservation-card .calendar-fullscreen-container .reservation-calendar-toolbar-container {
  position: sticky;
  top: 0;
  z-index: 30;
  background: var(--surface-card);
}
.reservation-page .reservation-card .calendar-fullscreen-container .rbc-toolbar::before,
.reservation-page .reservation-card .calendar-fullscreen-container .reservation-calendar-toolbar-container::before {
  content: "";
  position: absolute;
  top: calc(-1 * var(--page-padding));
  left: 0;
  right: 0;
  height: var(--page-padding);
  background: var(--surface-card);
  pointer-events: none;
}
.reservation-page .reservation-card .calendar-fullscreen-container .rbc-toolbar {
  margin-bottom: 0;
  padding-bottom: 12px;
}
.reservation-page .reservation-card .calendar-fullscreen-container .rbc-time-view {
  overflow: visible;
  border-top: none;
}
.reservation-page .reservation-card .calendar-fullscreen-container .rbc-time-header {
  position: sticky;
  top: var(--calendar-toolbar-height, 48px);
  z-index: 20;
  border-top: 1px solid var(--surface-border);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: var(--surface-card);
  overflow-y: auto;
  padding: 0 2px;
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen .rbc-calendar {
  height: auto;
  flex-shrink: 0;
  min-height: 100%;
  padding-bottom: max(32px, env(safe-area-inset-bottom));
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen .rbc-time-view {
  flex: 1 0 auto;
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen .rbc-time-content {
  flex: 1 0 auto;
  overflow-y: visible;
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen .rbc-toolbar {
  padding: 12px;
  padding-bottom: 8px;
  margin-bottom: 0;
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen .calendar-skeleton-container {
  height: 100%;
}
.reservation-page .reservation-card .calendar-fullscreen-container.is-fullscreen .calendar-skeleton-container .calendar-content {
  flex: 1;
}
.reservation-page .reservation-card .calendar-skeleton-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}
.reservation-page .reservation-card .calendar-skeleton-container .reservation-calendar-toolbar-container {
  padding: 0;
}
.reservation-page .reservation-card .calendar-skeleton-container .calendar-content .p-skeleton {
  height: 100%;
}
@media screen and (min-width: 769px) {
  .reservation-page .reservation-card.p-card {
    padding: 0;
  }
  .reservation-page .reservation-card > .p-card-header {
    padding: var(--space-4) var(--space-4) 0;
  }
  .reservation-page .reservation-card .calendar-filters {
    padding: 0 var(--space-4);
  }
  .reservation-page .reservation-card .calendar-fullscreen-container:not(.is-fullscreen) .rbc-toolbar {
    padding-left: var(--space-4);
    padding-right: var(--space-4);
  }
  .reservation-page .reservation-card .calendar-fullscreen-container:not(.is-fullscreen) .rbc-time-view {
    border-width: 0;
    border-radius: 0 0 calc(var(--radius-lg) - 1px) calc(var(--radius-lg) - 1px);
  }
  .reservation-page .reservation-card .calendar-fullscreen-container:not(.is-fullscreen) .rbc-time-header {
    border-radius: 0;
  }
  .reservation-page .reservation-card .calendar-fullscreen-container:not(.is-fullscreen) .rbc-time-content {
    border-radius: 0 0 calc(var(--radius-lg) - 1px) calc(var(--radius-lg) - 1px);
  }
  .reservation-page .reservation-card .calendar-fullscreen-container:not(.is-fullscreen) .calendar-skeleton-container .calendar-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .reservation-page .reservation-card .calendar-fullscreen-container:not(.is-fullscreen) .calendar-skeleton-container .calendar-content .p-skeleton {
    flex: 1;
    min-height: 900px;
    border-radius: 0 0 calc(var(--radius-lg) - 1px) calc(var(--radius-lg) - 1px);
  }
}
@media screen and (max-width: 480px) {
  .reservation-page .reservation-card .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0;
  }
  .reservation-page .reservation-card .rbc-toolbar button {
    padding: 8px 12px;
  }
}
@media screen and (max-width: 768px) {
  .reservation-page .reservation-card .reservation-header {
    flex-direction: column;
    align-items: stretch;
  }
  .reservation-page .reservation-card .reservation-header .header-right {
    justify-content: flex-end;
  }
  .reservation-page .reservation-card .filters-container {
    flex-direction: column;
  }
  .reservation-page .reservation-card .filters-container .branch-select,
  .reservation-page .reservation-card .filters-container .employee-select,
  .reservation-page .reservation-card .filters-container .type-select {
    width: 100%;
  }
}

.p-contextmenu .p-menuitem .p-menuitem-link {
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.p-contextmenu .p-menuitem .p-menuitem-link .p-menuitem-icon {
  margin: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
